import { getMinutesAndSecondsStringFromSeconds } from '../../DateTime';
import { isValidObject, isValidString } from '../../Validity';
import { getInitials } from '../../Website';

// ---------------------------------------------------------------------------------------------------------
// Goal
// ---------------------------------------------------------------------------------------------------------

export const goalDescription = (goal: any) => {
    if (isValidObject(goal)) {
        if (goal.team === 'our') {
            let desc = '';
            if (goal.period !== 'na') {
                desc += goal.period.toUpperCase();
            }
            if (goal.timeInSeconds !== 0) {
                if (isValidString(desc)) {
                    desc += ` - ${getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds)}`;
                } else {
                    desc += getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds);
                }
            }
            if (isValidString(goal.scorerName)) {
                if (isValidString(desc)) {
                    desc += ` - ${getInitials(goal.scorerName)}(G)`;
                } else {
                    desc += `${getInitials(goal.scorerName)}(G)`;
                }
            }
            if (isValidString(goal.assist1Name)) {
                if (isValidString(desc)) {
                    desc += ` - ${getInitials(goal.assist1Name)}(A)`;
                } else {
                    desc += `${getInitials(goal.assist1Name)}(A)`;
                }
            }
            return desc;
        }
        let desc = '';
        if (goal.period !== 'na') {
            desc += goal.period.toUpperCase();
        }
        if (goal.timeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds);
            }
        }
        return desc;
    }
    return null;
};

// ---------------------------------------------------------------------------------------------------------
// Highlight
// ---------------------------------------------------------------------------------------------------------

export const highlightDescription = (highlightPerPeriod: any) => {
    if (isValidObject(highlightPerPeriod)) {
        let desc = '';
        if (highlightPerPeriod.period !== 'na') {
            desc += highlightPerPeriod.period.toUpperCase();
        }
        if (highlightPerPeriod.type === 'shots') {
            if (isValidString(desc)) {
                desc += ` - ${highlightPerPeriod.number} shots`;
            } else {
                desc += `${highlightPerPeriod.number} shots`;
            }
        } if (highlightPerPeriod.type === 'blocks') {
            if (isValidString(desc)) {
                desc += ` - ${highlightPerPeriod.number} blocks`;
            } else {
                desc += `${highlightPerPeriod.number} blocks`;
            }
        } if (highlightPerPeriod.type === 'turnOvers') {
            if (isValidString(desc)) {
                desc += ` - ${highlightPerPeriod.number} turn overs`;
            } else {
                desc += `${highlightPerPeriod.number} turn overs`;
            }
        } if (highlightPerPeriod.type === 'groundBalls') {
            if (isValidString(desc)) {
                desc += ` - ${highlightPerPeriod.number} ground balls`;
            } else {
                desc += `${highlightPerPeriod.number} ground balls`;
            }
        } if (highlightPerPeriod.type === 'saves') {
            if (isValidString(desc)) {
                desc += ` - ${highlightPerPeriod.number} saves`;
            } else {
                desc += `${highlightPerPeriod.number} saves`;
            }
        }
        return desc;
    }
    return null;
};

// ---------------------------------------------------------------------------------------------------------
// Powerplay
// ---------------------------------------------------------------------------------------------------------

export const powerplayDescription = (powerplay: any) => {
    if (isValidObject(powerplay)) {
        let desc = '';
        if (powerplay.period !== 'na') {
            desc += powerplay.period.toUpperCase();
        }
        if (powerplay.endTimeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` | From: ${getMinutesAndSecondsStringFromSeconds(powerplay.startTimeInSeconds)} - To: ${getMinutesAndSecondsStringFromSeconds(powerplay.endTimeInSeconds)}`;
            } else {
                desc += `From: ${getMinutesAndSecondsStringFromSeconds(powerplay.startTimeInSeconds)} - To: ${getMinutesAndSecondsStringFromSeconds(powerplay.endTimeInSeconds)}`;
            }
        }

        if (isValidString(desc)) {
            return `${desc} | Shots: ${powerplay.shots} | Opponent Shots: ${powerplay.opponentShots} | Goals: ${powerplay.goals}`;
        }

        return `Shots: ${powerplay.shots} | Opponent Shots: ${powerplay.opponentShots} | Goals: ${powerplay.goals}`;
    }
    return null;
};

// ---------------------------------------------------------------------------------------------------------
// Penalty
// ---------------------------------------------------------------------------------------------------------

export const penaltyDescription = (penalty: any) => {
    if (isValidObject(penalty)) {
        let desc = '';
        if (penalty.period !== 'na') {
            desc += penalty.period.toUpperCase();
        }
        if (penalty.timeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(penalty.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(penalty.timeInSeconds);
            }
        }
        if (penalty.team === 'our') {
            if (isValidString(penalty.playerName)) {
                if (isValidString(desc)) {
                    desc += ` - ${getInitials(penalty.playerName)}`;
                } else {
                    desc += getInitials(penalty.playerName);
                }
            }
        }
        if (penalty.penaltyTimeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - Penalty Time: ${getMinutesAndSecondsStringFromSeconds(penalty.timeInSeconds)}`;
            } else {
                desc += `Penalty Time: ${getMinutesAndSecondsStringFromSeconds(penalty.timeInSeconds)}`;
            }
        }

        if (isValidString(desc)) {
            return `${desc} - Type: ${penalty.type} - Offence: ${fullPenaltyOffence(penalty.offence)}`;
        }
        return `Type: ${penalty.type} - Offence: ${fullPenaltyOffence(penalty.offence)}`;
    }
    return null;
};

export const fullPenaltyOffence = (offence: string) => {
    switch (offence) {
        case 'butt':
            return 'Butt-Ending';
        case 'behind':
            return 'Checking From Behind';
        case 'fighting':
            return 'Fighting';
        case 'fight-instigator':
            return 'Fight Insitigator';
        case 'facemask':
            return 'Holding/Grasping the Facemask';
        case 'push':
            return 'Pushing-off of Opponent with Skate';
        case 'leave':
            return 'Leaving the bench during an Altercation';
        case 'spearing':
            return 'Spearing';
        case 'minor-injury':
            return 'Intentional Minor Injury';
        case 'boarding':
            return 'Boarding';
        case 'warding':
            return 'Warding';
        case 'manUp':
            return 'Man Up';
        case 'manDown':
            return 'Man Down';
        case 'offside':
            return 'Offside';
        case 'inOut':
            return 'In-out of the crease';
        case 'falseStart':
            return 'False Start';
        case 'charging':
            return 'Charging';
        case 'contact-head':
            return 'Contact to the Head';
        case 'cross-checking':
            return 'Cross-Checking';
        case 'game-delay':
            return 'Delay of Game';
        case 'elbowing':
            return 'Elbowing';
        case 'slashing':
            return 'Slashing';
        case 'roughing':
            return 'Roughing';
        case 'obstruction':
            return 'Obstruction';
        case 'high-sticking':
            return 'High Sticking';
        case 'kneeing':
            return 'Kneeing';
        case 'holding':
            return 'Holding';
        case 'holding-stick':
            return 'Holding the Stick';
        case 'interference':
            return 'Interference';
        case 'hooking':
            return 'Hooking';
        case 'unsportsmanlike':
            return 'Unsportsmanlike Conduct';
        case 'tripping':
            return 'Tripping';
        default:
            return '';
    }
};
